document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quality-swiper]').forEach(function (wrapper) {
    var id = wrapper.dataset.qualitySwiper;
    new Swiper('.quality-swiper.swiper-' + id, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
      speed: 700,
      pagination: {
        el: '.progressbar-' + id,
        type: 'progressbar'
      },
      breakpoints: {
        1200: { slidesPerView: 4, spaceBetween: 20 },
        992: { slidesPerView: 3, spaceBetween: 20 },
        768: { slidesPerView: 2, spaceBetween: 16 },
        500: { slidesPerView: 1.5, spaceBetween: 8 },
        0: { slidesPerView: 1.5, spaceBetween: 12 }
      }
    });
  });
});
